import trl from './Translator';
import navi from './Navi';
import dbg from './Debug';
import scheduler from './Scheduler';
import util from './Util'

export class IframeChannel {
    bindings = [];
    notifyQueue = [];
    active = false;

    private channel;
    reconnectTimeout;

    addBinding(name, callback) {
        this.bindings.push({
            name: name,
            callback: callback
        });

        if (this.channel) {
            this.channel.bind(name, callback);
            dbg.log('ClientApplication binding registered: ' + name);
        }
    }

    connect(iframeWindow) {
        let origin = () => {
            let loc = window.location;
            let defaultOrigin = loc.protocol + '://' + loc.hostname;

            let ifr = $('#app-iframe');
            if (ifr.length == 0)
                return defaultOrigin;

            let iframeSrc = ifr.attr('src');
            if (!!iframeSrc) {
                let uri = util.parseURI(iframeSrc);
                return uri.protocol + '://' + uri.host;
            }

            return defaultOrigin;
        }

        this.channel = Channel.build({
            window: iframeWindow,
            origin: origin(),
            scope: 'ClientApplication',
            onReady: ()=> {
                dbg.log('ClientApplication Channel ready in the host');
                this.active = true;

                var notif;
                while (!!(notif = this.notifyQueue.pop())) {
                    this.notifyApplication(notif);
                }
            },

            messageObserver: (msg)=> {
                dbg.log(msg);
            }
        })


        this.bindings.forEach((b)=> {
            this.channel.bind(b.name, b.callback);
            dbg.log('ClientApplication binding attached: ' + b.name);
        });

        this.channel.bind('ping', (trn)=> {
            //dbg.log('ClientApplication channel ping received from iframe');
            trn.complete('pong');
        });
    }

    notifyApplication(invocation) {
        if (!!this.channel) {
            this.channel.notify(invocation);
            return;
        }
        this.notifyQueue.push(invocation);
    }

    callApplication(invocation) {
        return new Promise((resolve, reject) => {
            this.channel.call(_.extend({
                timeout: 120000,
                success: resolve,
                error: reject
            }, invocation))
        });
    }

    destroy() {
        if (!this.channel)
            return;
        this.channel.destroy();
        this.channel = null;
        this.active = false;
    }

    ping() {
        return new Promise((resolve, reject) => {
            if (!this.channel) {
                reject('ClientApplication channel not initialized');
                this.active = false;
                return;
            }

            this.channel.call({
                method: 'ping',
                timeout: 1000,
                success: resolve,
                error: reject
            });
        });
    }
}


let ifc = new IframeChannel();

let channelCheck = function (eventType) {
    //console.log('(re)checking ClientApplication channel, event: ' + eventType);

    if ($('#app-iframe').length != 1 || !$('#app-iframe')[0]['src']) {
        if (ifc.reconnectTimeout)
            clearTimeout(ifc.reconnectTimeout);
        return;
    }

    let iframeWindow = $('#app-iframe')[0]['contentWindow'];
    if (!iframeWindow || typeof iframeWindow['postMessage'] !== 'function') {
        dbg.log('can not use postMessage, not starting iframe communication channel');
        return;
    }

    ifc.reconnectTimeout = setTimeout(() => {
        ifc.ping().then(
            (pong) => {
                // connection ok
                //dbg.log('ClientApplication channel ping ok');
                ifc.active = true;
            },
            (error) => {
                // connection not ok, reconnect
                dbg.log('ClientApplication channel ping failed, (re)connecting');
                ifc.destroy();
                ifc.connect(iframeWindow);
            }
        );
    }, 100);
}

// check the connection immediately on navigation or language selection.
navi.bind(navi.Event.POST_NAVIGATE, channelCheck.bind(null, 'navi'));
trl.bind(trl.Event.LANGUAGE_CHANGED, channelCheck.bind(null, 'language'));

// and check periodically as well since the connection drops on every kind
// of reload inside the iframe.
scheduler.setInterval(null, channelCheck.bind(null, 'scheduled'), 500, true, {});

export default ifc;


// WEBPACK FOOTER //
// ./src/main/ui/core/application/IframeChannel.ts